export default "__VITE_PUBLIC_ASSET__e403904d__"